<template id="ComplianceHistory">
  <b-table
    sticky-header="400px"
    striped
    hover
    no-border-collapse
    primary-key="repoid"
    :items="items"
    :fields="fields"
  >
    <template v-slot:cell(readmeMD)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(readmeValid)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(securityMD)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(securityMatch)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(licenseTxt)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(licenseValid)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
    <template v-slot:cell(issuesCompliance)="data">
      <compliance-icon :complianceState="data.value" />
    </template>
  </b-table>
</template>

<script>
import { yearMonthDayTimeFormat } from "../common/time_utils";
import { ComplianceIcon } from "./icons";
export default {
  name: "ComplianceHistory",
  props: {
    complianceData: Array,
    checkNow: Function,
    loadMore: Function,
  },
  components: {
    ComplianceIcon,
  },
  data() {
    return {
      fields: [
        "timestamp",
        "readmeMD",
        "readmeValid",
        "securityMD",
        "securityMatch",
        "licenseTxt",
        "licenseValid",
        "issuesCompliance",
      ],
    };
  },
  computed: {
    items: function() {
      if (this.complianceData) {
        return this.complianceData.map((current) => {
          return {
            ...current,
            timestamp: yearMonthDayTimeFormat(new Date(current.timeStamp)),
          };
        });
      } else {
        return [];
      }
    },
  },
};
</script>
